<template>
  <div class="news news-component wd-1200">

    <moduleTitle :large="large" :moduleFlag="moduleFlag" />

    <div class="news-list clearFix">
      <div class="news-list-item" v-for="(item, index) in moduleInfo" :key="index">
        <img @click="handleCheckNews(item.url)" :src="item.image"/>
        <div class="news-list-info">
          <div class="news-list-info_title" @click="handleCheckNews(item.url)">{{ item.title }}</div>
          <div class="news-list-info_title">{{ item.time }}</div>
        </div>
      </div>
    </div>
    <div class="more" v-if="isMore">
      <span @click="handleMore">查看更多</span>
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Array,
        default: () => []
      },
      moduleFlag: {
        type: String,
        default: '',
      },
      isMore: {
        type: Boolean,
        default: true
      },
      large: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    methods: {
      handleCheckNews(url) {
        window.location.href = url
      },
      handleMore() {
        // this.$router.push({ name: 'news' })
        this.$router.push({ 
          name: 'news',
          params: {
            moduleIndex: this.moduleFlag.split('_')[1]
          }
        })
      }
    },
    created() {
      // console.log('news', this.moduleInfo)
    }
  }
</script>

<style scoped lang="scss">
  .news {
    .news-list {
      width: 1200px;

      .news-list-item {
        width: 542px;
        height: 108px;
        color: #333;
        box-sizing: border-box;
        overflow: hidden;
        float: left;
        box-shadow: 0 0 24px 0 rgba(39,73,255,0.10);

        img {
          display: inline-block;
          width: 192px;
          height: 100%;
          margin-right: 16px;
          float: left;
          cursor: pointer;
        }

        .news-list-info {
          width: 320px;
          color: #A6A6A6;
          float: left;

          .news-list-info_title:nth-of-type(1) {
            height: 56px;
            overflow: hidden;
            cursor: pointer;
            font-size: 16px;
            line-height: 28px;
            color: #333;
            margin: 8px 16px 14px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            &:hover {
              color: var(--themeColor);
            }
          }

          .news-list-info_title:nth-of-type(2) {
            font-size: 14px;
            line-height: 16px;
          }
        }
      }
      .news-list-item:nth-of-type(1) {
        width: 640px;
        height: 360px;
        box-sizing: border-box;
        overflow: hidden;
        margin-right: 18px;
        box-shadow: 0 0 24px 0 rgba(39, 73, 255, 0.10);
        position: relative;

        img {
          width: 640px;
          height: 360px;
        }

        .news-list-info {
          position: absolute;
          width: 100%;
          height: 72px;
          left: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, .7);

          .news-list-info_title:nth-of-type(1) {
            color: #fff;
            width: 580px;
            height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            line-height: 28px;
            padding: 12px 0 8px 30px;
            margin: 0;
          }

          .news-list-info_title:nth-of-type(2) {
            padding: 0 30px 0;
            font-size: 14px;
            line-height: 16px;
          }
        }
      }
      .news-list-item:nth-of-type(2), .news-list-item:nth-of-type(3) {
        margin-bottom: 18px;
      }
    }
  }
</style>
